// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"63dce3e4","57":"bbc3fb6b","124":"acbe6e49","174":"8984a0cf","353":"b50ff5b6","453":"db74b6f0","660":"309053ea","697":"58e5aeb5","712":"6dbf7bf4","819":"b41b6b63","832":"7b3eee4d"}[chunkId] + ".chunk.js";
};